module.exports = __webpack_public_path__ + "img/10_reasons_to_become_a_bricklayer_splash.1a17d282.jpg";